import { useState } from "react";
import { Sheet } from "./Sheet";

export function InstallHint() {
  const [open, setOpen] = useState(false);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="mt-3 flex w-full items-center justify-center gap-1.5 text-center text-sm font-medium text-ink-400 dark:text-night-faint"
      >
        <span aria-hidden="true">📲</span> Wie bekomme ich die App aufs Handy?
      </button>

      <Sheet open={open} onClose={() => setOpen(false)} title="Zum Homescreen hinzufügen">
        <p className="text-sm leading-relaxed text-ink-600 dark:text-night-muted">
          {isIOS
            ? 'Im Browser unten auf das Teilen-Symbol tippen, dann auf "Zum Home-Bildschirm" — danach startet Wir wie eine eigene App, ganz ohne Browser drumherum.'
            : 'Im Browser-Menü auf "App installieren" bzw. "Zum Startbildschirm hinzufügen" tippen — danach startet Wir wie eine eigene App, ganz ohne Browser drumherum.'}
        </p>
        <button
          onClick={() => setOpen(false)}
          className="mt-5 h-11 w-full rounded-xl bg-plum-700 text-sm font-semibold text-cream-50"
        >
          Verstanden
        </button>
      </Sheet>
    </>
  );
}
